// Deprecated. Please refrain from new usage
import React from "react";
export const VerticalDivider = () => (
  <div
    style={{
      height: "100%",
      width: 0,
      borderLeft: "1px solid rgba(124, 124, 124, 0.5)",
    }}
  />
);
